/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorStaging from './tumor-staging';
import TumorStagingDetail from './tumor-staging-detail';
import TumorStagingUpdate from './tumor-staging-update';
import TumorStagingDeleteDialog from './tumor-staging-delete-dialog';

const TumorStagingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorStaging />} />
    <Route path="new" element={<TumorStagingUpdate />} />
    <Route path=":id">
      <Route index element={<TumorStagingDetail />} />
      <Route path="edit" element={<TumorStagingUpdate />} />
      <Route path="delete" element={<TumorStagingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorStagingRoutes;
